
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/uas",
      function () {
        return require("private-next-pages/uas.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/uas"])
      });
    }
  